import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';

const Navigation = ({ t, currentLang, onLanguageChange }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo">Lucas Gonzales</div>
        
        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <div className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <button className="nav-link" onClick={() => scrollToSection('about')}>
            {t.nav.about}
          </button>
          <button className="nav-link" onClick={() => scrollToSection('skills')}>
            {t.nav.skills}
          </button>
          <button className="nav-link" onClick={() => scrollToSection('projects')}>
            {t.nav.projects}
          </button>
          <button className="nav-link" onClick={() => scrollToSection('contact')}>
            {t.nav.contact}
          </button>
          <LanguageSwitcher 
            currentLang={currentLang} 
            onLanguageChange={onLanguageChange} 
          />
        </div>
      </div>
    </nav>
  );
};

export default Navigation;